












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { GaiaHex } from "@gaia-project/engine";
import { hexCenter } from "../graphics/hex";
import SpaceHex from "./SpaceHex.vue";
import { CubeCoordinates, Hex } from "hexagrid";

@Component<Sector>({
  components: {
    SpaceHex,
  },
})
export default class Sector extends Vue {
  @Prop()
  center: CubeCoordinates;

  centerOffset(hex: GaiaHex) {
    return hexCenter({
      q: hex.q - this.center.q,
      r: hex.r - this.center.r,
    });
  }

  isCenter(hex: GaiaHex) {
    return hex.q === this.center.q && hex.r === this.center.r;
  }

  get map() {
    return this.$store.state.data.map;
  }

  get sector(): GaiaHex[] {
    const coords = Hex.hexagon(2, { center: this.center });
    const ret = coords.map((coord) => this.map.grid.get(coord)).filter(h => h);

    return ret;
  }
}
